import { putReq, getReq, uploadReq } from '../api/restHelper';
import { getWsRecords } from './app';
import { toast } from 'react-toastify';

export function getUser(phone){
    return (dispatch) => {
        getReq('user/' + phone, (res)=>{
            dispatch({type:'SET_USER', payload: res.data})
        }, ()=>{}, false)
    }
}

export function updateUser(obj, actions){
    return (dispatch) => {
        let sendObj = Object.assign({}, obj)
        delete sendObj.phone_number
        putReq(sendObj, 'user', (res)=>{
            dispatch({type:'SET_USER', payload: res.data})

            const appData = JSON.parse(localStorage.getItem('appData'));
            const newAppData = Object.assign({}, appData, {user: res.data});
            
            localStorage.appData = JSON.stringify(newAppData);
            actions.setSubmitting(false);

        }, (res)=>{
            console.log(res)
            actions.setSubmitting(false);
        })
    }
}

export function uploadCsv(file, v){
    return (dispatch, getState) => {
        v.setState({fileLoading: true})
        const data = new FormData();
        data.append('file', file);
        data.append('workspace', getState().app.work_space.id);
        uploadReq(data, 'import/record', (res)=>{
            v.setState({fileLoading: false})
            toast.success("ریکورد ها با موفقیت به حساب شما اضافه شدند.");
            getWsRecords()
        }, (res)=>{
            v.setState({fileLoading: false})
        });
    }
}

